import { render, staticRenderFns } from "./help.svg?vue&type=template&id=22e4ae04"
var script = {}


/* normalize component */
import normalizer from "!../../../../../ridget/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports